/**
 * Dialog themeable props.
 */
import { stringLiteralArray } from "../../utils"

export default {
  // TODO: We need to figure out a pattern for how subcomponent styling works
  appearances: stringLiteralArray(["default", "none"])
}
